import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import Topbar from "../topBar";
import Sidebar from "../sideBar";
import axios from "axios";
import Cookies from "universal-cookie";
import { API as url1 } from "../../config";
import  Swal  from "sweetalert2/dist/sweetalert2";
import { CATEGORY, DASHBOARD, EDIT_CATEGORY } from "../../constants/url";
import { ERR_ALERT_TITLE, ERR_GETTING } from "../../constants/alertMessage";
import { privateApiCall } from "../../api/privateApi";
const cookies = new Cookies();

export default class edit_category extends Component {
  componentDidMount() {
    
  const requestUrl =`${EDIT_CATEGORY}/${this.props.match.params._id}/?token=${cookies.get("agritech_token")}`
     privateApiCall(requestUrl,'GET')
      .then(
        (res) => {
          this.setState({ name: res.data.category[0].name });
          this.setState({ image: res.data.category[0].image });
        },
        (err) => {
          Swal.fire({
            title: `${err}`,
            icon: "error",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        }
      )
      .catch(()=>{
        Swal.fire({
          title:`${ERR_ALERT_TITLE}`,
          icon: `${ERR_GETTING}`,
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      })
  }

  constructor() {
    super();
    window.postMessage("renderTable", "*");

    this.state = {
      name: "",
      image: "",
      data: [],
      description: "",
      color: "",
    };

    this.handlenameChange = this.handlenameChange.bind(this);
    this.changeicon = this.changeicon.bind(this);
    this.handledescriptionChange = this.handledescriptionChange.bind(this);
    this.color = this.color.bind(this);
  }

  changeicon(event) {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.setState({ image: e.target.result });
      };
      reader.readAsDataURL(event.target.files[0]);
    } else {
      this.setState({ image: "http://placehold.it/60/c2c2c2?text=User" });
    }
  }

  handlenameChange(event) {
    this.setState({ name: event.target.value });
  }
  handledescriptionChange(event) {
    this.setState({ description: event.target.value });
  }
  color(event) {
    this.setState({ color: event.target.value });
  }
  render() {
    return (
      <div id="wrapper">
        <Topbar backgroundColor="#769A0F" />
        <Sidebar />
        <div className="content-page">
          <div className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box">
                    <h4 className="page-title float-left">Edit category</h4>

                    <ol className="breadcrumb float-right">
                      <li className="breadcrumb-item">
                        {" "}
                        <NavLink to={DASHBOARD}>Dashboard</NavLink>
                      </li>
                      <li className="breadcrumb-item">
                        {" "}
                        <NavLink to={CATEGORY}>categorys</NavLink>
                      </li>
                      <li className="breadcrumb-item active">Edit category</li>
                    </ol>

                    <div className="clearfix"></div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="card-box" style={{ paddingBottom: "50px" }}>
                    <h4 className="m-t-0 m-b-30 header-title"></h4>

                    <form
                      
                      method="post"
                      enctype="multipart/form-data"
                      action={`${EDIT_CATEGORY}/${
                        this.props.match.params._id
                      }/?token=${cookies.get("agritech_token")}`}
                    >
                      <div className="form-group">
                        <label>Category Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter name"
                          value={this.state.name}
                          name="name"
                          onChange={this.handlenameChange}
                          required
                        />
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <label for="exampleInputEmail1">
                            Category Image<sup className="color-danger">*</sup>
                          </label>
                          <div className="form-group">
                            <img
                              className="img-responsive"
                              src={this.state.image}
                              alt="user"
                              style={{ width: "150px", height: "150px" }}
                            />
                            <br />
                            <input
                              type="file"
                              className="form-control"
                              id="image"
                              name="image"
                              onChange={this.changeicon}
                              placeholder=""
                            />
                          </div>
                        </div>
                      </div>

                      <button
                        type="submit"
                        className="btn btn-primary"
                        style={{ float: "left", backgroundColor: "#11abff" }}
                      >
                        Submit
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
